import { render, staticRenderFns } from "./CourseEditForm.vue?vue&type=template&id=9b18afea"
import script from "./CourseEditForm.vue?vue&type=script&lang=js"
export * from "./CourseEditForm.vue?vue&type=script&lang=js"
import style0 from "./CourseEditForm.vue?vue&type=style&index=0&id=9b18afea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports